import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TextField from "@material-ui/core/TextField";

import HeroImage1 from "../../utils/images/hero001.webp";
import HeroImage2 from "../../utils/images/hero002.webp";
import HeroImage3 from "../../utils/images/hero003.webp";
import { useDispatch } from "react-redux";
import { MdArrowForwardIos } from "react-icons/md";
import { setServices } from "../../redux-toolkit/snabbkollenSlice";
import "./HeroSection.css";
const Autocomplete = React.lazy(() => import("@material-ui/lab/Autocomplete"));

const Hero = ({ h1 }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const handleSearchChange = (e, value) => {
    e.preventDefault();
    dispatch(setServices(value));
    const currentUrl = location.pathname + location.search;
    navigate(
      `/forfragan?tjanst=${encodeURIComponent(value)}&path=${encodeURIComponent(currentUrl)}`
    );
  };

  const images = [HeroImage1, HeroImage2, HeroImage3]; // Array of images

  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to change the current image
  const changeImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Set interval to change image every 3 seconds
  useEffect(() => {
    const interval = setInterval(changeImage, 3000);
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  const servicesArray = [
    {
      title: "Webbdesign",
    },
    {
      title: "Sökmotoroptimering (SEO)",
    },
    {
      title: "Digital marknadsföring",
    },
    {
      title: "Sociala medier hantering",
    },
    {
      title: "E-postmarknadsföring",
    },
    {
      title: "PPC-annonsering (Pay-per-click)",
    },
    {
      title: "Innehållsstrategi",
    },
    {
      title: "Webbanalys",
    },
  ];

  return (
    <div className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="h1-name">CENTRUM FÖR ALLA </span>
          <br />
          {h1 ? h1 : "Bästa webbyrå som finns i Sverige"}
        </h1>
        <div className="search-bar">
          <Autocomplete
            onChange={handleSearchChange}
            background="white"
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={servicesArray.map((option) => option.title)}
            renderInput={(params) => (
              <TextField
                className="search-input"
                {...params}
                placeholder="Hur kan vi hjälpa dig"
                margin="normal"
                variant="standard"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  disableUnderline: true,
                }}
              />
            )}
          />
          <button
            onClick={() => navigate("/forfragan")}
            aria-label="Navigate to inquiry form"
          >
            <MdArrowForwardIos style={{ fontSize: "1rem" }} />
          </button>
        </div>
      </div>
      <div className="hero-gradient"></div>

      <div className="hero-image">
        <img src={HeroImage1} alt="Web development solutions" />
        <img src={HeroImage2} alt="SEO and digital marketing" />
        <img src={HeroImage3} alt="Social media management" />
      </div>
      <div className="waveWrapper waveAnimation">
        <div className="waveWrapperInner bgTop">
          <div className="wave waveTop"></div>
        </div>
        <div className="waveWrapperInner bgMiddle">
          <div className="wave waveMiddle"></div>
        </div>
        <div className="waveWrapperInner bgBottom">
          <div className="wave waveBottom"></div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
